import React, { Component } from "react";
//
import Screen from "./ConnectedScreen";
import LocationPicker from "../components/LocationPicker";
import Alert from "../components/Alert";
import Button from "../components/Button";

const geo = navigator.geolocation;

class LocationScreen extends Component {
  _search = (query) => this.props.searchPlace(query);

  _onNext = (ev) => this.props.setLocation(this.props.location.id);

  _forceLocation = (ev) => this.props.forceLocation(this.props.location.id);

  render() {
    const {
      error,
      outcall,
      city,
      location,
      places,
      editing,
      getLocation,
    } = this.props;

    let title;

    if (outcall) {
      title = "Where are you staying?";
    } else {
      title = "Where will you be traveling from?";
    }

    return (
      <Screen
        title={title}
        isActive
        onNext={this._onNext}
        nextDisabled={!location || Boolean(error)}
        nextLabel={editing ? "Save" : "Next"}
        prevLabel={editing ? "Cancel" : "Back"}
      >
        <LocationPicker
          className="u-mb"
          placeholder="e.g. Novotel"
          places={places}
          location={location || null}
          onInput={this._search}
          onSelect={getLocation}
          city={city}
        />
        {error !== null && (
          <Alert error>
            <p>{error}</p>
            <a className="u-link" onClick={this._forceLocation}>
              Search for escorts near
            </a>{" "}
            <strong>{location.name}</strong> instead?
          </Alert>
        )}
        {location === null && (
          <Alert
            info
            text="We need your location in order to show you the nearest escorts
          available around you."
          />
        )}
      </Screen>
    );
  }
}

// @connect
import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
//
import { searchPlaceAction } from "../modules/places";
import {
  getLocationAction,
  setLocationAction,
  forceLocationAction,
} from "../modules/locations";
import { getCity, getPlaces, getPreviewLocation } from "../selectors";

const state = (state) => {
  const { error, message } = state.ajax;

  return {
    error: error === "location_too_far" && message ? message : null,
    outcall: state.booking.outcall,
    city: getCity(state),
    location: getPreviewLocation(state),
    places: getPlaces(state),
    editing: state.models.active !== null,
  };
};

const actions = (dispatch) =>
  bindActions(
    {
      searchPlace: searchPlaceAction,
      getLocation: getLocationAction,
      setLocation: setLocationAction,
      forceLocation: forceLocationAction,
    },
    dispatch
  );

export default connect(
  state,
  actions
)(LocationScreen);
